module.exports = __webpack_public_path__ + "static/media/warranty_bottom.84b833e1.png";